/* document.addEventListener("DOMContentLoaded", function() {
  const nav = document.querySelector(".nav-bar__linklist.list--unstyled.main_nav-bar_linklist");
  if (nav) {
    nav.insertAdjacentHTML("beforeend", `
      <li class="nav-bar__item item-has-mega-menu">
        <a href="/pages/каталог" class="nav-bar__link link" data-type="menuitem" aria-expanded="false" aria-haspopup="true">
          <span>Каталог</span>
          <!-- svg icons -->
        </a>
        <ul class="nav-dropdown nav-dropdown--restrict" data-type="menu" aria-hidden="true">
          <li class="nav-dropdown__item"><a href="/pages/готови-решения" class="nav-dropdown__link link"><span>За стълбища</span></a></li>
          <li class="nav-dropdown__item"><a href="/pages/готови-решения" class="nav-dropdown__link link"><span>За тераси</span></a></li>
          <li class="nav-dropdown__item"><a href="/collections/всички-продукти" class="nav-dropdown__link link"><span>Всички елементи</span></a></li>
        </ul>
      </li>
    `);
  }
}); */


/* Mobile Menu */
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".js-toggle-submenu").forEach(function (btn) {
    const icon = btn.querySelector(".mobile-nav__icon");
    if (!icon) return;

    const newBtn = btn.cloneNode(true);
    btn.parentNode.replaceChild(newBtn, btn);
    const newIcon = newBtn.querySelector(".mobile-nav__icon");

    newIcon.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const link = newBtn.querySelector("a.mobile-nav-stretched-link");
      if (link) {
        link.setAttribute("data-skip", "true");
      }

      newBtn.click();

      if (link) {
        link.removeAttribute("data-skip");
      }
    });

    newBtn.addEventListener("click", function (e) {
      if (e.target.closest(".mobile-nav__icon")) {
        e.preventDefault();
        return;
      }

      const link = newBtn.querySelector("a.mobile-nav-stretched-link");
      if (link && !link.hasAttribute("data-skip")) {
        e.preventDefault();
        window.location.href = link.href;
      }
    });
  });
});















